import da from 'date-fns/locale/da';
import de from 'date-fns/locale/de';
import it from 'date-fns/locale/it';
import pt from 'date-fns/locale/pt';
import nl from 'date-fns/locale/nl';
import es from 'date-fns/locale/es';
import fi from 'date-fns/locale/fi';
import fr from 'date-fns/locale/fr';
import enCA from 'date-fns/locale/en-CA';
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import hu from 'date-fns/locale/hu';
import { Currency } from '@/data/country.config';

export const defaultLocale = {
  country: 'GB',
  language: 'en',
};

export const i18nConfig = {
  fallbackLocale: `${defaultLocale.language}-${defaultLocale.country}`,
  locale: `${defaultLocale.language}-${defaultLocale.country}`,
  messages: {
    'en-DE': {
      error_msg_server: 'Server Error',
      error_msg_server_description: 'There was a server error',
      error_msg_unknown: 'There was an unknown error',
    },
  },
  numberFormats: {
    'en-CA': {
      currency: {
        currency: Currency.CAD,
        style: 'currency' as const,
      },
    },
    'en-DE': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'de-DE': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'pt-PT': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'es-ES': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'fi-FI': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'fr-FR': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'nl-NL': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'it-IT': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'fr-BE': {
      currency: {
        currency: Currency.EUR,
        style: 'currency' as const,
      },
    },
    'hu-HU': {
      currency: {
        currency: Currency.HUF,
        style: 'currency' as const,
      },
    },
    'en-HU': {
      currency: {
        currency: Currency.HUF,
        style: 'currency' as const,
      },
    },
    'sv-SE': {
      currency: {
        currency: Currency.SEK,
        style: 'currency' as const,
      },
    },
    'en-SE': {
      currency: {
        currency: Currency.SEK,
        style: 'currency' as const,
      },
    },
    'da-DK': {
      currency: {
        currency: Currency.DKK,
        style: 'currency' as const,
      },
    },
    'en-DK': {
      currency: {
        currency: Currency.DKK,
        style: 'currency' as const,
      },
    },
    'en-US': {
      currency: {
        currency: Currency.USD,
        style: 'currency' as const,
      },
    },
    'en-GB': {
      currency: {
        currency: Currency.GBP,
        style: 'currency' as const,
      },
    },
  },
  silentTranslationWarn: true,
};

export const dateLocales = new Map<string, object>([
  ['de-AT', de],
  ['en-AT', enGB],
  ['de-DE', de],
  ['en-DE', enGB],
  ['en-US', enUS],
  ['en-CA', enCA],
  ['fr-CA', fr],
  ['en-ES', enGB],
  ['es-ES', es],
  ['en-NL', enGB],
  ['nl-NL', nl],
  ['en-IT', enGB],
  ['it-IT', it],
  ['en-FR', enGB],
  ['fr-FR', fr],
  ['da-DK', da],
  ['en-DA', enGB],
  ['hu-HU', hu],
  ['en-HU', enGB],
  ['pt-PT', pt],
  ['en-PT', enGB],
  ['fi-FI', fi],
  ['en-FI', enGB],
  ['en-GB', enGB],
  ['fr-BE', fr],
  ['en-BE', enGB],
]);

export const getSupportedLocale = (locale: string) => {
  switch (true) {
    case /^fr/.test(locale):
      return 'fr-FR';
    case /^it/.test(locale):
      return 'it-IT';
    case /^pt/.test(locale):
      return 'pt-PT';
    case /^es/.test(locale):
      return 'es-ES';
    case /^de/.test(locale):
      return 'de-DE';
    case /^at/.test(locale):
      return 'de-AT';
    case /^nl/.test(locale):
      return 'nl-NL';
    case /^hu/.test(locale):
      return 'hu-HU';
    case /^da/.test(locale):
      return 'da-DK';
    default:
      return `${defaultLocale.language}-${defaultLocale.country}`;
  }
};
